import React, { useState } from "react";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../../context/useFetch";
import TableIconModal from "../../../shares/TableIconModal";

const ChangeOrderState = (props) => {
  let windowWidth = window.screen.width;
  const [openModal, setOpenModal] = useState(false);

  const createLog = useFetch({
    method: "post",
    url: `Order_Service/${props.selectedRow?.id}/create_order_log`,
    data: { state: "order_change_state" },
    argFunc: (res) => {},
    errMessage: (mess) => {},
  });

  const updateOrderApi = useFetch({
    method: "patch",
    url: `Order_Service/${props.selectedRow?.id}/admin_revert_order_from_complete_to_onprogress`,
    trigger: false,
    data: { state: "onprogress" },
    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      createLog.reFetch();
      setOpenModal(false);
      props.adminGetCustomerReceviedOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const provider_change_order_to_waiting = () => {
    updateOrderApi.reFetch();
  };

  return (
    <>
      <TableIconModal
        width="w-2/5"
        isRemove={true}
        removeText="آیا از تغییر وضعیت  به سفارش  جاری اطمینان دارید؟"
        icon={<ImportExportIcon />}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleRemoveOnClick={provider_change_order_to_waiting}
      ></TableIconModal>
    </>
  );
};

export default ChangeOrderState;
